const reIsHostCtor = /^\[object .+?Constructor\]$/
export default reIsHostCtor
